import Collections from '../../utils/collections';
import BaseDocument from '../../Model/BaseDocument';

const SmartContextResponsesCacheStatus = {
  FRESH: 'FRESH',
  STALE: 'STALE',
  INVALID: 'INVALID',
};

class SmartContextResponsesCache extends BaseDocument {
  constructor(id, opts) {
    super(`${Collections.SMART_CONTEXT_RESPONSES_CACHE}/${id}`, opts);
  }

  get docData() {
    return this.data.data || {};
  }

  get traceId() {
    return this.data.traceId || '';
  }

  get status() {
    return this.data.status || SmartContextResponsesCacheStatus.INVALID;
  }

  get updatedAt() {
    return this.data.updatedAt;
  }

  get version() {
    return this.data.version;
  }

  /**
   * The pre-generated suggested reply for one chat thread. Keyed by channel, because the draft is
   * written in that thread's coach's voice and a client can hold a thread with more than one coach.
   * @param {string} channelId - The chat channel the draft belongs to.
   */
  static async getSmartContextResponsesCacheByChannelId(channelId) {
    const smartContextResponsesCacheDoc = new SmartContextResponsesCache(channelId);
    await smartContextResponsesCacheDoc.init();
    return smartContextResponsesCacheDoc;
  }
}

export default SmartContextResponsesCache;

export {
  SmartContextResponsesCacheStatus,
};
